export default "__VITE_ASSET__9de58cb0__"